import * as actionTypes from '../actions/sidebarMenuCountActionTypes';

const initialState = {
    getSidebarMenuCount: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TRUE_CALL_SIDEBAR_MENU_COUNT:
            return {
                ...state,
                getSidebarMenuCount: true, // Set to true when called
            };

        case actionTypes.FALSE_CALL_SIDEBAR_MENU_COUNT:
            return {
                ...state,
                getSidebarMenuCount: false, // Set to false when called
            };

        default:
            return state;
    }
};

export default reducer;